import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { Observable } from 'rxjs';
import { BaseContentService } from './base-content-service';
import { map } from 'rxjs/internal/operators/map';
import { catchError } from 'rxjs/internal/operators/catchError';
import { of } from 'rxjs/internal/observable/of';
import { ForgotPassword } from './def/forgotPassword';

@Injectable({
  providedIn: 'root'
})
export class ForgotPasswordService extends BaseContentService<ForgotPassword> {
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService
  ) {
    super(http, configService, ForgotPasswordService.staticForgotPass);
  }

  get data$(): Observable<ForgotPassword> {
    if (!this.loaded) {
      return this.getForgetPasswordData();
    }

    return of(this.data);
  }

  getForgetPasswordData(): Observable<ForgotPassword> {
    const url = `${this.serviceBaseUrl}forgotpassword`;
    return this.get<ForgotPassword>(url).pipe(
      map(data => {
        this.data = this.forgotPasswordMapper(data);
        this.loaded = true;
        return this.data;
      }),
      catchError(this.handleError)
    );
  }

  private forgotPasswordMapper(data: ForgotPassword): ForgotPassword {
    if (!data) return;

    return data;
  }

  private static staticForgotPass: ForgotPassword = {
    pageName: 'forgotpassword',
    forms: [
      {
        formName: '',
        isAdvanceSearch: false,
        fields: [
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: 1,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: [
                {
                  key: '',
                  value: ''
                }
              ]
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: 2,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: [
                {
                  key: '',
                  value: ''
                },
                {
                  key: '',
                  value: ''
                }
              ]
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: 3,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: [
                {
                  key: '',
                  value: ''
                },
                {
                  key: '',
                  value: ''
                }
              ]
            },
            config: null
          }
        ]
      }
    ],
    data: [
      {
        heading: '',
        title: '',
        description: '',
        text: '',
        image: null,
        displayItems: []
      }
    ]
  };

  forgotPasswordModal() {
    return {
      data: '',
      modalSetting: {
        title: '',
        hideHeader: false,
        hideFooter: true,
        hideHeaderX: false, // header X button;
        hideSave: true,
        closeOnOutsideClick: true
      }
    };
  }
}
